import { Amenity } from "@b2bportal/lodging-api";
import Accessibility from "../../assets/icons/hotel/amenities/Accessibility.svg?react";
import AirConditioning from "../../assets/icons/hotel/amenities/AirConditioning.svg?react";
import AirportShuttle from "../../assets/icons/hotel/amenities/AirportShuttle.svg?react";
import Baby from "../../assets/icons/hotel/amenities/Baby.svg?react";
import Bar from "../../assets/icons/hotel/amenities/Bar.svg?react";
import Bbq from "../../assets/icons/hotel/amenities/Bbq.svg?react";
import Beach from "../../assets/icons/hotel/amenities/Beach.svg?react";
import BedDoubleSolid from "../../assets/icons/hotel/amenities/BedDoubleSolid.svg?react";
import BedSingleSolid from "../../assets/icons/hotel/amenities/BedSingleSolid.svg?react";
import Bell from "../../assets/icons/hotel/amenities/Bell.svg?react";
import Breakfast from "../../assets/icons/hotel/amenities/Breakfast.svg?react";
import BusinessServicesOutline from "../../assets/icons/hotel/amenities/BusinessServicesOutline.svg?react";
import Coffee from "../../assets/icons/hotel/amenities/Coffee.svg?react";
import CrossOut from "../../assets/icons/hotel/amenities/CrossOut.svg?react";
import Essential from "../../assets/icons/hotel/amenities/Essential.svg?react";
import Fallback from "../../assets/icons/hotel/amenities/Fallback.svg?react";
import Gym from "../../assets/icons/hotel/amenities/Gym.svg?react";
import HairDryer from "../../assets/icons/hotel/amenities/HairDryer.svg?react";
import Heat from "../../assets/icons/hotel/amenities/Heat.svg?react";
import HotTub from "../../assets/icons/hotel/amenities/HotTub.svg?react";
import Kitchen from "../../assets/icons/hotel/amenities/Kitchen.svg?react";
import Laptop from "../../assets/icons/hotel/amenities/Laptop.svg?react";
import Laundry from "../../assets/icons/hotel/amenities/Laundry.svg?react";
import Outdoors from "../../assets/icons/hotel/amenities/Outdoors.svg?react";
import Parking from "../../assets/icons/hotel/amenities/Parking.svg?react";
import PetFriendlyOutline from "../../assets/icons/hotel/amenities/PetFriendlyOutline.svg?react";
import Pool from "../../assets/icons/hotel/amenities/Pool.svg?react";
import Restaurant from "../../assets/icons/hotel/amenities/Restaurant.svg?react";
import Spa from "../../assets/icons/hotel/amenities/Spa.svg?react";
import Tv from "../../assets/icons/hotel/amenities/Tv.svg?react";
import Wifi from "../../assets/icons/hotel/amenities/Wifi.svg?react";
import type { SvgrComponent } from "../typings";

interface SvgrComponentWithAlt extends SvgrComponent {
  alt?: string;
}

const amenityIconCollection: {
  [key in Amenity]: SvgrComponentWithAlt;
} = {
  [Amenity.Accessibility]: Accessibility,
  [Amenity.AccessibleBathroom]: Accessibility,
  [Amenity.AdultsOnly]: CrossOut,
  [Amenity.AirConditioning]: AirConditioning,
  [Amenity.AirportTransportation]: AirportShuttle,
  [Amenity.AirportTransportationAvailableGeneral]: AirportShuttle,
  [Amenity.Bar]: Bar,
  [Amenity.BarbecueGrill]: Bbq,
  [Amenity.BarOrLounge]: Bar,
  [Amenity.Beach]: Beach,
  [Amenity.BrailleOrRaisedSignage]: Accessibility,
  [Amenity.BreakfastIncluded]: Breakfast,
  [Amenity.BusinessCenter]: BusinessServicesOutline,
  [Amenity.BusinessFacilities]: BusinessServicesOutline,
  [Amenity.Childcare]: Baby,
  [Amenity.CoffeeMaker]: Coffee,
  [Amenity.CoffeeTea]: Coffee,
  [Amenity.ComputerStation]: Laptop,
  [Amenity.ConferenceSpace]: BusinessServicesOutline,
  [Amenity.DryCleaningLaundryService]: Laundry,
  [Amenity.Entertainment]: Tv,
  [Amenity.FitnessCenter]: Gym,
  [Amenity.FitnessFacilities]: Gym,
  [Amenity.FreeAirportTransportation]: AirportShuttle,
  [Amenity.FreeBreakfast]: Breakfast,
  [Amenity.FreeSelfParking]: Parking,
  [Amenity.FreeWifi]: Wifi,
  [Amenity.FullServiceSpa]: Spa,
  [Amenity.HairDryer]: HairDryer,
  [Amenity.Heating]: Heat,
  [Amenity.HomeEssentials]: Essential,
  [Amenity.HomeInfo]: BedDoubleSolid,
  [Amenity.HotTub]: HotTub,
  [Amenity.IndoorPool]: Pool,
  [Amenity.InRoomAccessibility]: Accessibility,
  [Amenity.KidFriendly]: Baby,
  [Amenity.KitchenEssentials]: Kitchen,
  [Amenity.Laundry]: Laundry,
  [Amenity.LaundryFacilities]: Laundry,
  [Amenity.MeetingRooms]: BusinessServicesOutline,
  [Amenity.NumberOfBarsOrLounges]: Bar,
  [Amenity.NumberOfRestaurants]: Restaurant,
  [Amenity.OutdoorPool]: Pool,
  [Amenity.OutdoorSeasonalPool]: Pool,
  [Amenity.OutdoorSpace]: Outdoors,
  [Amenity.PaidBreakfast]: Breakfast,
  [Amenity.PaidSelfParking]: Parking,
  [Amenity.PaidValetParking]: Parking,
  [Amenity.Parking]: Parking,
  [Amenity.ParkingAvailableGeneral]: Parking,
  [Amenity.PetFriendly]: PetFriendlyOutline,
  [Amenity.PetsAllowed]: PetFriendlyOutline,
  [Amenity.PetsAllowedNoFees]: PetFriendlyOutline,
  [Amenity.PetsOnlyCats]: PetFriendlyOutline,
  [Amenity.PetsOnlyDogs]: PetFriendlyOutline,
  [Amenity.PetsOnlyDogsAndCats]: PetFriendlyOutline,
  [Amenity.Pool]: Pool,
  [Amenity.PoolGeneral]: Pool,
  [Amenity.PoolsideBar]: Bar,
  [Amenity.Restaurant]: Restaurant,
  [Amenity.RollawayOrExtraBedsAvailable]: BedSingleSolid,
  [Amenity.RollInShower]: Accessibility,
  [Amenity.RoomWifi]: Wifi,
  [Amenity.RoundTheClockCheckIn]: Bell,
  [Amenity.SomeAccessibilityFeaturesAvailableGeneral]: Accessibility,
  [Amenity.Spa]: Spa,
  [Amenity.SpaTreatmentRoom]: Spa,
  [Amenity.SteamRoom]: Spa,
  [Amenity.SwimmingPool]: Pool,
  [Amenity.TwentyFourHourFitnessFacilities]: Gym,
  [Amenity.TwentyFourHourFrontDesk]: Bell,
  [Amenity.WheelchairAccessibleParking]: Accessibility,
  [Amenity.WheelchairAccessiblePathOfTravel]: Accessibility,
  [Amenity.Workspace]: BusinessServicesOutline,

  // TODO: These amenities need icons.
  [Amenity.Arcade]: Fallback,
  [Amenity.AtmBanking]: Fallback,
  [Amenity.BeachEssentials]: Fallback,
  [Amenity.Casino]: Fallback,
  [Amenity.ConciergeServices]: Fallback,
  [Amenity.ElectricCarCharging]: Fallback,
  [Amenity.ExpressCheckIn]: Fallback,
  [Amenity.Garden]: Fallback,
  [Amenity.Golf]: Fallback,
  [Amenity.HairSalon]: Fallback,
  [Amenity.HikingOrBikingNearby]: Fallback,
  [Amenity.Library]: Fallback,
  [Amenity.LuggageStorage]: Fallback,
  [Amenity.Nightclub]: Fallback,
  [Amenity.PorterBellhop]: Fallback,
  [Amenity.SafeDepositBoxFrontDesk]: Fallback,
  [Amenity.Sauna]: Fallback,
  [Amenity.SnackOrDeli]: Fallback,
  [Amenity.Tennis]: Fallback,
  [Amenity.Terrace]: Fallback,
  [Amenity.ToursTicketAssistance]: Fallback,
  [Amenity.WaterPark]: Fallback,
  [Amenity.BigBath]: Fallback,
  [Amenity.Dinner]: Fallback,
  [Amenity.HotSpring]: Fallback,
  [Amenity.JapaneseStyle]: Fallback,
  [Amenity.NaturalSpring]: Fallback,
  [Amenity.OpenAirBath]: Fallback,
  [Amenity.PrivateBath]: Fallback,
  [Amenity.PrivateOpenAirBath]: Fallback,
  [Amenity.Smoking]: Fallback,
  [Amenity.WesternStyle]: Fallback,
};

export { amenityIconCollection as AmenityIconCollection };
